export const introList = [
  {
    pageID: "OATLY",
    logo: "/images/Productpage/product-1/product-1-logo.png",
    productBgcStyle: "product product--bgc1",
    productListStyle: "product__list product__list--m1",
    leftStyle: "dec-left dec-left--1 ",
    rightStyle: "dec-right dec-right--1",
    h1: "OATLY 燕麥奶系列",
    main: "來自瑞典的OATLY，是歐洲燕麥製品領域的品牌，如今 Oatly 被公認為最受歡迎、最具生命力的瑞典品牌之一，其中咖啡師口味就連星巴克、Blue Bottle 也愛用，更在台灣咖啡廳刮起燕麥奶拿鐵的旋風！",
    span: "",
    h2: "Oatly 秉持三大核心理念：",
    section: [
      "· 永續發展 (Sustainability)",
      "· 營養健康 (Nutrition and Health)",
      "· 信任 (Trust)"
    ],
    img: "/images/Productpage/product-1/product-1-bottom.png",
    textStyle: "blue-bgc",
    product: [
      {
        id: "b0101",
        brand: "OATLY",
        name: "原味燕麥奶",
        product__img: "/images/productDB/product-1-1.png",
        intro__img: "/images/productDB/intro-1-1.png",
        price: "1314"
      },
      {
        id: "b0102",
        brand: "OATLY",
        name: "咖啡師燕麥奶",
        product__img: "/images/productDB/product-1-2.png",
        intro__img: "/images/productDB/intro-1-2.png",
        price: "1314"
      },
      {
        id: "b0103",
        brand: "OATLY",
        name: "巧克力燕麥奶",
        product__img: "/images/productDB/product-1-3.png",
        intro__img: "/images/productDB/intro-1-3.png",
        price: "1314"
      }
    ]
  },
  {
    pageID: "CALIFIA",
    logo: "/images/Productpage/product-2/product-2-logo.png",
    productListStyle: "product__list product__list--m2",
    productBgcStyle: "product product--bgc2",
    leftStyle: "dec-left dec-left--2 ",
    rightStyle: "dec-right dec-right--2",
    h1: "CALIFIA FARMS 燕麥奶系列",
    main: "來自美國加州，CalifiaFarms相信食物應該回到它最原始提供營養的初衷，透過這個理念及提供以植物為原料的產品，希望可以和大家一起為地球永續盡一份心力。",
    span: "Let's eat, learn and love together.",
    h2: "商品特色：",
    section: [
      "· 無添加糖份",
      "· 低麩質，純素可用",
      "· 不添加增稠劑或穩定劑",
      "· 非基因改造作物"
    ],
    img: "",
    textStyle: "blue-bgc",
    product: [
      {
        id: "b0201",
        brand: "CALIFA FARMS",
        name: "咖啡師燕麥奶",
        product__img: "/images/productDB/product-2-1.png",
        intro__img: "/images/productDB/intro-2-1.png",
        price: "1200"
      },
      {
        id: "b0202",
        brand: "CALIFA FARMS",
        name: "濃醇燕麥奶",
        product__img: "/images/productDB/product-2-2.png",
        intro__img: "/images/productDB/intro-2-2.png",
        price: "1350"
      },
      {
        id: "b0203",
        brand: "CALIFA FARMS",
        name: "高蛋白燕麥奶",
        product__img: "/images/productDB/product-2-3.png",
        intro__img: "/images/productDB/intro-2-3.png",
        price: "1520"
      }
    ]
  },
  {
    pageID: "MINOR",
    logo: "/images/Productpage/product-3/product-3-logo.png",
    productBgcStyle: "product product--bgc3",
    productListStyle: "product__list product__list--m3",
    leftStyle: "dec-left dec-left--3 ",
    rightStyle: "dec-right dec-right--3",
    h1: "MINOR FIGURES 燕麥奶系列",
    main: "來自美國加州，CalifiaFarms相信食物應該回到它最原始提供營養的初衷，透過這個理念及提供以植物為原料的產品，希望可以和大家一起為地球永續盡一份心力。",
    span: "Let's eat, learn and love together.",
    h2: "品牌靈魂角色：「熊麥師」",
    section: [
      "描繪出品牌富有朝氣且俏皮的鮮明",
      "風格，以「OATSIDE OF LIFE」，",
      "打造獨有的正能量生活風格。"
    ],
    img: "",
    textStyle: "yellow-bgc",
    product: [
      {
        id: "b0301",
        brand: "MINOR FIGURES",
        name: "咖啡師燕麥奶",
        product__img: "/images/productDB/product-3-1.png",
        intro__img: "/images/productDB/intro-3-1.png",
        price: "1214"
      },
      {
        id: "b0302",
        brand: "MINOR FIGURES",
        name: "低脂燕麥奶",
        product__img: "/images/productDB/product-3-2.png",
        intro__img: "/images/productDB/intro-3-2.png",
        price: "1314"
      },
      {
        id: "b0303",
        brand: "MINOR FIGURES",
        name: "濃厚燕麥奶",
        product__img: "/images/productDB/product-3-3.png",
        intro__img: "/images/productDB/intro-3-3.png",
        price: "1400"
      }
    ]
  },
  {
    pageID: "OATSIDE",
    logo: "/images/Productpage/product-4/product-4-logo.png",
    productBgcStyle: "product product--bgc4",
    productListStyle: "product__list product__list--m4",
    leftStyle: "dec-left dec-left--4 ",
    rightStyle: "dec-right dec-right--4",
    h1: "OATSIDE 燕麥奶系列",
    main: "來自新加坡，OATSIDE的燕麥奶採用100%澳洲高品質燕麥，以獨特的技術打造出獨一無二的順口感，以穩定高溫烘烤燕麥提升堅果及麥香層次，恰到好處的濃度口感，讓人一喝就愛上。",
    span: "",
    h2: "品牌靈魂角色：「熊麥師」",
    section: [
      "描繪出品牌富有朝氣且俏皮的鮮明",
      "風格，以「OATSIDE OF LIFE」，",
      "打造獨有的正能量生活風格。"
    ],
    img: "",
    textStyle: "blue-bgc",
    product: [
      {
        id: "b0401",
        brand: "OATLY",
        name: "職人燕麥奶",
        product__img: "/images/productDB/product-4-1.png",
        intro__img: "/images/productDB/intro-4-1.png",
        price: "1414"
      },
      {
        id: "b0402",
        brand: "OATLY",
        name: "巧克力榛子燕麥奶",
        product__img: "/images/productDB/product-4-2.png",
        intro__img: "/images/productDB/intro-4-2.png",
        price: "1524"
      },
      {
        id: "b0403",
        brand: "OATLY",
        name: "巧克力燕麥奶",
        product__img: "/images/productDB/product-4-3.png",
        intro__img: "/images/productDB/intro-4-3.png",
        price: "1134"
      }
    ]
  }
];
